export { default } from './src/modal-portal';
